import { StringIterator } from "lodash"

export interface IntegrationColumn {
	key: string
	title: string
	dataType: string
}

export interface SetupColumn extends IntegrationColumn {

}

export interface Integration {
	id: string
	title: string
	description: string
	supportLink: string
	usesServices: boolean
	setupColumns: SetupColumn[]

	inbound: {
		mappableData: IntegrationColumn[]
		allowCustomEvents: boolean
		events: IntegrationEventMapping[] | null
	} | null

	outbound: IntegrationOut | null
}

export interface IntegrationEventMapping {
	key: string
	title: string
	description: string
}

export interface IntegrationSettings {
	integrationId: string
	enabled: boolean
	configuration: { [key: string]: any }
	inFieldMapping: { [key: string]: string }
	eventMapping: { [key: string]: string }
	outConfiguration: { [key: string]: OutConfiguration }
}

export interface IntegrationWithSettings {
	integration: Integration
	settings: IntegrationSettings | null
}

export interface IntegrationSummary {
	integrationKey: string
	title: string
	description: string

	usesServices: boolean
	allowForceRun: boolean
}

export interface IntegrationStatus {
	lastChecked: Date | null
	nextCheck: Date | null
}

export interface IntegrationOutOption {
	integrationKey: string
	integrationTitle: string
	integrationOut: string
	integrationOutTitle: string
}

export enum ServiceStatus {
	Ok,
	Warning,
	Error,
	Offline
}

export interface IntegrationService {
	id: string
	environmentName: string
	status: ServiceStatus | null,
	statusText: string
}

export enum MessageType {
	Error,
	Warning,
	Information
}

export interface IntegrationLog {
	serviceId: string
	caseId: string
	occurred: Date
	messageType: MessageType
	message: string
}

export interface OutSettings {
	key: string
	title: string
	description: string
	setupColumns: IntegrationColumn[]
	supportsTrackingChanges: boolean
}

export interface IntegrationOut {
	supportRaise: boolean
	supportOutFieldMapping: boolean
	out: OutSettings[]
	mappableData:IntegrationColumn[]
}

export interface OutConfiguration {
	key: string
	outputType: string | null
	title: string
	enabled: boolean
	outFieldMapping: { [key: string]: string }
	configuration: { [key: string]: any }
	onDemandPermissions: string[] | null
}
